import React from 'react';
import { motion } from 'framer-motion';
import {
  Users, BookOpen, Eye, CreditCard, TrendingUp,
  Crown, Clock, Trash2, Shield, ShieldOff, BarChart3,
  Link2, Percent, Euro, Plus, Copy, Check as CheckIcon, X,
  Ban, UserCheck, Gift, CalendarPlus, Download, History, MoreVertical, Mail, Send, Tag
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../ui/dropdown-menu';

export const NotificationsTab = ({ ctx }) => {
  const { emailNotifications, approvedStories, handleSendNotification, sendingNotification } = ctx;
  return (
  <TabsContent value="notifications" className="space-y-6">
              {/* Send New Notification */}
              <Card className="border-0 shadow-sm">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Send className="w-5 h-5 text-gold" />
                    Nieuw Verhaal Aankondigen
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground mb-4">
                    Selecteer een verhaal om alle gebruikers te notificeren via e-mail.
                    {!process.env.REACT_APP_RESEND_CONFIGURED && (
                      <span className="block mt-1 text-amber-600">
                        Demo-modus: E-mails worden gelogd (configureer RESEND_API_KEY voor echte verzending)
                      </span>
                    )}
                  </p>
                  
                  {approvedStories.length === 0 ? (
                    <p className="text-muted-foreground">Geen goedgekeurde verhalen beschikbaar.</p>
                  ) : (
                    <div className="space-y-3">
                      {approvedStories.slice(0, 5).map(story => (
                        <div key={story.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                          <div className="flex items-center gap-3">
                            {story.cover_image_url && (
                              <img 
                                src={story.cover_image_url.startsWith('/api') 
                                  ? `${process.env.REACT_APP_BACKEND_URL}${story.cover_image_url}` 
                                  : story.cover_image_url}
                                alt={story.title}
                                className="w-12 h-16 object-cover rounded"
                              />
                            )}
                            <div>
                              <p className="font-medium">{story.title}</p>
                              <p className="text-sm text-muted-foreground">door {story.grandma_name}</p>
                            </div>
                          </div>
                          <Button
                            size="sm"
                            onClick={() => handleSendNotification(story.id)}
                            disabled={sendingNotification}
                            className="gap-2"
                            data-testid={`notify-story-${story.id}`}
                          >
                            <Mail className="w-4 h-4" />
                            {sendingNotification ? 'Verzenden...' : 'Notificeren'}
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Notification History */}
              <Card className="border-0 shadow-sm">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <History className="w-5 h-5 text-gold" />
                    Verstuurde Notificaties
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {emailNotifications.length === 0 ? (
                    <p className="text-muted-foreground">Nog geen notificaties verstuurd.</p>
                  ) : (
                    <div className="space-y-3">
                      {emailNotifications.map(notification => (
                        <div key={notification.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                          <div>
                            <p className="font-medium">{notification.story_title}</p>
                            <p className="text-sm text-muted-foreground">
                              {notification.recipients_count} ontvangers • {new Date(notification.created_at).toLocaleDateString('nl-NL', { 
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </p>
                          </div>
                          {notification.demo_mode && (
                            <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded">DEMO</span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            </TabsContent>
  );
};
